import { buildSvgString, type SvgStringOpts } from '../../svgString';

import { data } from './data';

export const CheckSVG = (opts?: SvgStringOpts): string => buildSvgString(data, opts);

export default CheckSVG;
